import { MatPaginatorIntl } from '@angular/material/paginator'
import { Injectable } from '@angular/core'

@Injectable()
export class CustomPaginatorIntl extends MatPaginatorIntl {
  override itemsPerPageLabel = 'Einträge pro Seite'
  override nextPageLabel = 'Nächste Seite'
  override previousPageLabel = 'Vorherige Seite'
  override firstPageLabel = 'Erste Seite'
  override lastPageLabel = 'Letzte Seite'

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return `0 von ${length}`
    }

    const startIndex = page * pageSize
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize

    return `${startIndex + 1} - ${endIndex} von ${length}`
  }
}
